import React from "react";
import { X } from "lucide-react";
import UseContext from "hooks/useContext";
import ToolProviderSelect from "pages/missionTemplates/components/ToolProviderSelect";
import Tooltip from "components/tooltips/Tooltips";
import { toolIcon } from "components/missionDetail/missionDetailIcons";

/**
 * The template's equipment, one line each read as a sentence: "Gilet service apporté par
 * l'intérimaire", the provider switched from the underlined word, the cross to remove it. Each
 * tool has its family icon, the same as in the temp worker app (toolIcon).
 */
const TemplateToolList = ({ tools, onProviderChange, onRemove }) => {
    const { language } = UseContext();

    if (!tools?.length) return null;

    const providerSelectLabel = language.getValue("missionTemplate.tools.providerSelectLabel", "Fournisseur");
    const removeLabel = language.getValue("missionTemplate.tools.removeLabel", "Retirer");

    return (
        <ul className="divide-y divide-gray-100 rounded-lg border border-gray-100 bg-white">
            {tools.map((tool) => {
                const Icon = toolIcon(tool.name);
                return (
                    <li key={tool.name} className="flex items-center gap-2 px-4 py-3">
                        <Icon size={20} color="#1f2937" strokeWidth={2} className="mr-1 shrink-0" aria-hidden="true" />
                        <span className="min-w-0 break-words text-sm font-medium text-gray-900">{tool.name}</span>
                        <span className="flex-1">
                            <ToolProviderSelect
                                value={tool.providedBy}
                                onChange={(providedBy) => onProviderChange(tool.name, providedBy)}
                                ariaLabel={`${providerSelectLabel} : ${tool.name}`}
                            />
                        </span>
                        <Tooltip text={removeLabel} placement="top">
                            <button
                                type="button"
                                onClick={() => onRemove(tool.name)}
                                aria-label={`${removeLabel} ${tool.name}`}
                                className="rounded-md p-1.5 text-gray-500 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-500"
                            >
                                <X size={16} aria-hidden="true" />
                            </button>
                        </Tooltip>
                    </li>
                );
            })}
        </ul>
    );
};

export default TemplateToolList;
